module.exports = __webpack_public_path__ + "img/TopCreativeLeader.6dd2ce8c.jpg";